import * as Yup from "yup";
import { form, AppendixForm } from "./form";

const checkout = form;
const checkoutAppendix = AppendixForm;

const {
  formField: {
    address,
    certificate,
    fullName,
    firstTime,
    signer,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxId,
    taxId2,
    taxpayerName,
    timeSign,
    miningAddress,
    taxAgentContract,
  },
} = checkout;
const {
  formFieldAppendix: {
    taxCalculationPeriodAppendix,
    firstTimeAppendix,
    supplementaryForTheAppendix,
    taxpayerNameAppendix,
    taxIdAppendix,
  },
} = checkoutAppendix;

const validation = Yup.object().shape({
  // [address.name]: Yup.string().required(address.errorMsg),
  // [certificate.name]: Yup.string().required(certificate.errorMsg),
  // [fullName.name]: Yup.string().required(fullName.errorMsg),
  // [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  // [miningAddress.name]: Yup.string().required(miningAddress.errorMsg),
  // [taxAgentContract.name]: Yup.string().required(taxAgentContract.errorMsg),
  // [signer.name]: Yup.string().required(signer.errorMsg),
  // [supplementaryForThe.name]: Yup.string()
  //   .matches(/^\d+$/, supplementaryForThe.invalidMsg)
  //   .required(supplementaryForThe.errorMsg),
  // [taxAgencyId.name]: Yup.string()
  //   .matches(/^\d{10}(?:-\d{3})?$/, taxAgencyId.invalidMsg)
  //   .required(taxAgencyId.errorMsg),
  // [taxAgencyName.name]: Yup.string().optional(),
  // [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  // [taxId.name]: Yup.string()
  //   .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
  //   .required(taxId.errorMsg),
  // [taxId2.name]: Yup.string()
  //   .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
  //   .required(taxId.errorMsg),
  // [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
  // [timeSign.name]: Yup.number().required(timeSign.errorMsg),
});

export default validation;
